import React, { useState, useEffect } from 'react'
import ModalInc from '../../../../../shared-ui/ModalInc'
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import Grid from "@material-ui/core/Grid"
import AlertDialog from '../../../../../components/AlertDialog/index.es6'
import { CircularProgress } from '@material-ui/core'
import { getUserFullname } from '../../../../../lib/access.es6'

const EditClaimNote = (props) => {
console.log("edit claim note props", props)
  const [note, setNote] = useState('')
  const [description, setDescription] = useState('')

  useEffect(() => {
    if (props.note) {
      setNote(props.note.text || '')
      setDescription(props.note.description || '')
    }
    // Reset any previous error states when opening the modal
    if (props.resetUpdateNotesErrorAlert) {
      props.resetUpdateNotesErrorAlert()
    }
    if (props.resetUpdateNotesSuccessAlert) {
      props.resetUpdateNotesSuccessAlert()
    }
  }, [props.note, props.resetUpdateNotesErrorAlert, props.resetUpdateNotesSuccessAlert])

  const handleChange = (event) => {
    const { name, value } = event.target

    if (name === "notes") {
      setNote(value)
    } else if (name === "description") {
      setDescription(value)
    }
  }

  const reset = () => {
    setNote('')
    setDescription('')
  }

  const handleUpdateNote = () => {
    const payload = {
      "text": note,
      "description": description,
      "notes_guid": props.note.guid,
      "updated_by": getUserFullname(),
      "claim_guid": props.claimGuid
    }
    console.log("update notes payload", payload)
    props.onUpdate(payload)
    reset()
  }

  const handleNoteUpdatedSuccessfully = () => {
    props.resetNotesSuccessAlert()
    props.onClose()
    window.location.reload()
  }

  const handleNoteUpdateError = () => {
    props.resetNotesErrorAlert()
  }

  return (
    <>
      <AlertDialog
        custom
        show={props.showUpdateNoteProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2>Updating Claim Note...</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={props.showUpdateNotesSuccessAlert}
        size="sm"
        title={'Claim note updated'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handleNoteUpdatedSuccessfully() }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={true}
        cancelBtnText={'cancel'}
        confirmBtnCssClass
      >
      </AlertDialog>

      <AlertDialog
        show={props.showUpdateNotesErrorAlert}
        danger
        title={'Error updating claim note'}
        onConfirm={() => handleNoteUpdateError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        {props.UpdateNotesError ? props.UpdateNotesError.message : ''}
      </AlertDialog>

      <ModalInc
        modalTitle="Edit Claim Note"
        subTitle="Update the claim note details"
        open={props.open}
        onClose={props.onClose}
        fullWidth
      >
        <ValidatorForm onSubmit={() => handleUpdateNote()}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <TextValidator
                name='description'
                id="description"
                label="Description"
                value={description}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                validators={['required']}
                errorMessages={['Please enter description']}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextValidator
                name='notes'
                id="notes"
                label="Claim Notes (Text)"
                value={note}
                onChange={handleChange}
                multiline
                rows={5}
                maxRows={4}
                fullWidth
                variant="outlined"
                validators={['required']}
                errorMessages={['Please enter claim notes']}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={8} md={8}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    type='submit'
                    style={{ marginTop: "20px", float: "right" }}
                  >
                    Update Note
                  </ButtonInc>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{ marginTop: "20px" }}
                    onClick={props.onClose}
                  >
                    Cancel
                  </ButtonInc>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ValidatorForm>
      </ModalInc>
    </>
  )
}

export default EditClaimNote